import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {
  DEFAULT_LANGUAGE_CODE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
} from './shared/constants/language.contant';
import { StorageService } from 'ngx-mat-esign360';
import { EnvConfigService } from 'ngx-mat-esign360';
import { getCountryCodePrefix, isLanguageSupported } from 'ngx-mat-esign360';
import { transformToLanguageCodesArray } from './shared/utils/language.util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'start-signing';

  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private envConfig: EnvConfigService
  ) {
    this.translate.onLangChange.subscribe((lang: LangChangeEvent) => {
      this.saveAppLanguageToStore(lang.lang);
    });
  }

  ngOnInit(): void {
    this.initAppLanguage();
  }

  saveAppLanguageToStore(languageCode: string): void {
    if (this.isLanguageSupported(languageCode)) {
      this.storageService.saveData(LANGUAGE_STORAGE_KEY, languageCode);
    }
  }

  initAppLanguage(): void {
    const storedLanguageCode = this.storageService.getData(LANGUAGE_STORAGE_KEY);
    const browserLanguageCode = getCountryCodePrefix(navigator.language);
    const languageCode =
      storedLanguageCode && this.isLanguageSupported(storedLanguageCode)
        ? storedLanguageCode
        : browserLanguageCode && this.isLanguageSupported(browserLanguageCode)
        ? browserLanguageCode
        : this.envConfig.data.defaultLang
        ? this.envConfig.data.defaultLang
        : DEFAULT_LANGUAGE_CODE;

    this.saveAppLanguageToStore(languageCode);
    this.translate.use(languageCode);
  }

  isLanguageSupported(countryCode: string): boolean {
    return isLanguageSupported(countryCode, transformToLanguageCodesArray(SUPPORTED_LANGUAGES));
  }
}
